import { ModalType, Theme } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Closeable, { CloseEventListener } from '@philips-emr/tws-core/lib/component/types/closeable';
import Pageable, { PageEventListener } from '@philips-emr/tws-core/lib/component/types/pageable';
import { isEnumValid } from '@philips-emr/tws-utils';

class ModalAPI extends ComponentAPI implements Pageable, Closeable {

  /** @event */
  @AwesomeEvent
  onNextPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onPrevPage = new PageEventListener();

  /** @event */
  @AwesomeEvent
  onBeforeClose = new CloseEventListener();

  /** @event */
  @AwesomeEvent
  onClose = new CloseEventListener();

  close(): void {
    let close = true;

    const abortFn = (): void => { close = false; };
    this.onBeforeClose.fire({ abort: abortFn });

    close && this.onClose.fire();

  }

  getClassName(): string {
    return this.state.className;
  }

  setClassName(className: string): void {
    this.setState({ className });
  }

  isCloseByDocument(): boolean {
    return this.state.closeByDocument;
  }

  setCloseByDocument(closeByDocument: boolean): void {
    this.setState({ closeByDocument });
  }

  isCloseByEscape(): boolean {
    return this.state.closeByEscape;
  }

  setCloseByEscape(closeByEscape: boolean): void {
    this.setState({ closeByEscape });
  }

  isEnableNavigation(): boolean {
    return this.state.enableNavigation;
  }

  setEnableNavigation(enableNavigation: boolean): void {
    this.setState({ enableNavigation });
  }

  getTheme(): Theme {
    return this.state.theme;
  }

  setTheme(theme: Theme): void {
    if (isEnumValid(Theme, theme)) {
      this.setState({ theme });
    }
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }

  getType(): ModalType {
    return this.state.type;
  }

  setType(type: ModalType): void {
    if (isEnumValid(ModalType, type)) {
      this.setState({ type });
    }
  }
}

export default ModalAPI;
